module.exports = __webpack_public_path__ + "static/media/logo new.f85eda15.png";